import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';
import type { RequestOptions } from '@/libs/api/types';

export type GuardianPlayerSessionSummary = auth.GuardianPlayerSessionSummary;
export type GuardianPlayerSession = auth.GuardianPlayerSession;
export type GuardianPlayerSessionsResponse = auth.GuardianPlayerSessionsResponse;
export type GuardianPlayerSessionsParams = auth.GuardianPlayerSessionsParams;
export type GuardianPlayerSessionDetail = auth.GuardianPlayerSessionDetail;

export async function fetchGuardianPlayerSessionSummary(
  playerId: string,
  options?: RequestOptions,
): Promise<GuardianPlayerSessionSummary> {
  return await AuthServices.getGuardianPlayerSessionSummary(playerId, options);
}

export async function fetchGuardianPlayerSessions(
  playerId: string,
  params?: GuardianPlayerSessionsParams,
  options?: RequestOptions,
): Promise<GuardianPlayerSessionsResponse> {
  return await AuthServices.getGuardianPlayerSessions(playerId, params, options);
}

export async function fetchGuardianPlayerSessionDetail(
  playerId: string,
  sessionId: string,
  options?: RequestOptions,
): Promise<GuardianPlayerSessionDetail> {
  return await AuthServices.getGuardianPlayerSessionDetail(playerId, sessionId, options);
}
